//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {queryunhandlealarm, handleallalarm} from '../../api/device'

export default {
  model: {
    prop: 'unhandlAlarmShow',
    event: 'change'
  },
  name: 'alarmList',
  data () {
    return {
      deviceData: {},
      alarmList: [],
      cnt: 10,
      addWarn: false,
      showAdd: false,
      iconType: [
        {type: 'dooropen', url: '../../../static/NB/second_history_opendoor.png'},
        {type: 'doorclose', url: '../../../static/NB/second_history_closedoor.png'},
        {type: 'door-open', url: '../../../static/NB/second_history_opendoor.png'},
        {type: 'door-close', url: '../../../static/NB/second_history_closedoor.png'},
        {type: 'sos', url: '../../../static/NB/second_history_SOS.png'},
        {type: 'c-at', url: '../../../static/NB/second_history_dismantle.png'},
        {type: 'sys_isactivity', url: '../../../static/NB/second_history_other.png'},
        {type: 'lockrequsetopendoor', url: '../../../static/NB/doorbell.png'},
        {type: 'sendopenlock', url: '../../../static/NB/remotelock.png'},
        {type: 'water', url: '../../../static/NB/water.png'},
        {type: 'acoff', url: '../../../static/NB/ac_off.png'},
        {type: 'acon', url: '../../../static/NB/ac_on.png'},
        {type: 'achighttemp', url: '../../../static/NB/highttemp.png'},
        {type: 'lockopendoor', url: '../../../static/NB/second_history_opendoor.png'}, // 401开门
        {type: 'lockclosedoor', url: '../../../static/NB/second_history_closedoor.png'}, // 401关门
        {type: 'wifilock_open', url: '../../../static/NB/lock_on.png'}, // 401开锁
        {type: 'aclowtemp', url: '../../../static/NB/diwen.png'}, // 低温,
        {type: 'achightemp', url: '../../../static/NB/gaowen.png'}, // 高温,
        {type: 'aclowhumidity', url: '../../../static/NB/dishi.png'}, // 低湿
        {type: 'achighhumidity', url: '../../../static/NB/gaoshi.png'}, // 高湿
        {type: 'wifilock_open', url: '../../../static/NB/lock_on.png'}, //
        {type: 'wifilock_close', url: '../../../static/NB/lock_off.png'}, //
        {type: '', url: '../../../static/NB/second_history_other.png'}
      ]
    }
  },
  created () {
    this.deviceData = this.$store.getters.get_child_obj
    if (this.deviceData.unhandlealarm > 100) {
      this.cnt = 100
    } else {
      this.cnt = this.deviceData.unhandlealarm
    }
    this.getAlarmList()
  },
  methods: {
    getAlarmList () {
      // 建议unhandlealarm  < 100 ,填入具体数值；unhandlealarm  > 100 填入100
      let data = {
        dids: [this.deviceData.id],
        page: 1,
        cnt: this.cnt
      }
      queryunhandlealarm(data).then(res => {
        let data = res.data
        for (let i = 0; i < data.length; i++) {
          if (data[i].config !== '' && typeof data[i].config === 'string') {
            let config = JSON.parse(data[i].config)
            while (typeof config === 'string') {
              config = JSON.parse(config)
            }
            data[i].config = config
          }
        }
        this.alarmList = data
      }).catch(() => {})
    },
    getUrl (item) {
      let url = 'static/NB/second_history_other.png'
      for (let i = 0; i < this.iconType.length; i++) {
        if (this.iconType[i].type === item.alarm_type) {
          url = this.iconType[i].url
        }
      }
      return url
    },
    // 判断报警类型
    getAlarmType (atype) {
      return this.common.getAlarmType(atype)
    },
    getDname (item) {
      if (item.childdevice !== null) {
        let sub = item.childdevice.name
        if (item.childdevice.setname !== '') {
          sub = item.childdevice.setname
        }
        return item.device.name + '/' + sub
      } else if (item.device) {
        return item.device.name
      } else {
        return '未知设备'
      }
    },
    getShowVal (item) {
      let show = false
      if (item.subdid === 0) { // 主机
        if (item.device !== null) {
          if (item.device.dtype === 503 ||
            item.device.dtype === 504 ||
            item.device.dtype === 507 ||
            item.device.dtype === 753) {
            item.configJson = this.parseConfig(item)
            show = true
          }
        }
      } else { // 子机
        if (item.childdevice !== null) {
          if (item.childdevice.dtype === 2 ||
            item.childdevice.dtype === 12 ||
            item.childdevice.dtype === 13 ||
            item.childdevice.dtype === 52 ||
            item.childdevice.dtype === 11 ||
            item.childdevice.dtype === 14) {
            show = true
          }
        }
      }
      return show
    },
    parseConfig (alarmItem) {
      let config = {}
      if (alarmItem.config) {
        if (alarmItem.device.dtype === 753) {
          alarmItem.config.forEach(obj => {
            if (obj.m.indexOf('temperature') !== -1) {
              if (obj.m === 'temperature' || obj.m === 'temperature1') {
                config.temperature = obj.v
              } else if (obj.m === 'temperature2') {
                config.temperature2 = obj.v
              } else if (obj.m === 'temperature3') {
                config.temperature3 = obj.v
              } else if (obj.m === 'temperature4') {
                config.temperature4 = obj.v
              }
              // 温度
            } else if (obj.m.indexOf('humidity') !== -1) {
              if (obj.m === 'humidity' || obj.m === 'humidity1') {
                config.humidity = obj.v
              } else if (obj.m === 'humidity2') {
                config.humidity2 = obj.v
              } else if (obj.m === 'humidity3') {
                config.humidity3 = obj.v
              } else if (obj.m === 'humidity4') {
                config.humidity4 = obj.v
              }
              // 湿度
            }
          })
        }
      }
      return config
    },
    // 帕斯卡转兆帕
    getMPaName (pressure) {
      return pressure / 1000000
    },
    // 水位
    getLevelName (level) {
      return level / 100
    },
    // 获取探头数据
    getDeviceProbe (item, type) {
      let result = ''
      let result1 = ''
      let result2 = ''
      if (type === 'probe1') {
        result1 = item.configJson.temperature ? item.configJson.temperature + '℃' : '--'
        result2 = item.configJson.humidity ? item.configJson.humidity + '%' : '--'
        result = result1 + ' / ' + result2
      } else if (type === 'probe2') {
        result1 = item.configJson.temperature2 ? item.configJson.temperature2 + '℃' : '--'
        result2 = item.configJson.humidity2 ? item.configJson.humidity2 + '%' : '--'
        result = result1 + ' / ' + result2
      } else if (type === 'probe3') {
        result = item.configJson.temperature3 ? item.configJson.temperature3 + '℃' : '--'
      } else if (type === 'probe4') {
        result = item.configJson.temperature4 ? item.configJson.temperature4 + '℃' : '--'
      }

      return result
    },
    sendHandleAlarm () {
      let data = {
        did: this.deviceData.id,
        content: '已处理'
      }
      handleallalarm(data).then(res => {
        this.showAdd = true
        let vm = this
        this.$emit('getFatherChange', data.cnt)
        setTimeout(() => {
          vm.$emit('change', false)
        }, 1000)
      }).catch(() => {
        this.addWarn = true
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/device/alarmList.vue